/* ── Shared form control ── */
.input,
.select,
.textarea {
  display: block;
  width: 100%;
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
  color: var(--color-text);
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 0.625rem 0.75rem;
  min-height: 44px;
  transition: border-color var(--transition-fast),
              box-shadow var(--transition-fast);
  box-sizing: border-box;
}

.input:focus,
.select:focus,
.textarea:focus {
  outline: none;
  border-color: var(--color-border-focus);
  box-shadow: 0 0 0 2px rgba(104, 50, 141, 0.15);
}

.input:disabled,
.select:disabled,
.textarea:disabled {
  background-color: var(--color-bg-secondary);
  opacity: 0.6;
  cursor: not-allowed;
}

.error {
  border-color: var(--color-error);
}

.error:focus {
  border-color: var(--color-error);
  box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.15);
}

/* ── Select-specific ── */
.select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b6b6b' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2.25rem;
  cursor: pointer;
}

/* ── Textarea-specific ── */
.textarea {
  resize: vertical;
  min-height: 88px;
}
